import { useMemo } from "react";
import { useActionsColumn } from "./useActionsColumn";
import { useEarningGroupsColumns } from "./useEarningGroupsColumns";
import { useEmployeeNumberColumn } from "./useEmployeeNumberColumn";
import { useGroupColumns } from "./useGroupColumns";
import { useJobsColumn } from "./useJobsColumn";
import { useLocationsColumn } from "./useLocationsColumn";
import { useNameColumn } from "./useNameColumn";
import { usePayGroupColumn } from "./usePayGroupColumn";
import { usePaymentColumn } from "./usePaymentColumn";

import { useConfigurationModule } from "../../../../Settings/Configuration/hooks/useConfigurationModule";
import { useRetroAmountColumn, useRetroHoursColumn } from "./useRetroColumn";
import { useAccess } from "../../../../../utils/hooks/access";

export const useColumns = ({ viewSummary, viewProfile, canViewRates }) => {
	const hideWeeklySummary = useConfigurationModule("timeSheetTeam.timeSheet.hideWeeklySummary");
	const { hasAccess: canViewRetro } = useAccess("timeSheet.canViewRetro");

	const nameColumn = useNameColumn({ viewProfile });
	const employeeNumberColumn = useEmployeeNumberColumn();
	const payGroupColumn = usePayGroupColumn();
	const groupColumns = useGroupColumns();
	const locationsColumn = useLocationsColumn();
	const jobsColumn = useJobsColumn();
	const earningGroupsColumns = useEarningGroupsColumns({ canViewRates });

	const paymentColumn = usePaymentColumn();
	const retroHoursColumn = useRetroHoursColumn();
	const retroAmountColumn = useRetroAmountColumn();
	const actionsColumn = useActionsColumn({ viewSummary });

	return useMemo(
		() => {
			const columns = [
				nameColumn,
				employeeNumberColumn,
				payGroupColumn,
				...groupColumns,
				locationsColumn,
				jobsColumn,
				...earningGroupsColumns,
			];
			if (canViewRetro) {
				columns.push(retroHoursColumn);
				if (canViewRates) {
					columns.push(retroAmountColumn);
				}
			}

			if (canViewRates) {
				columns.push(paymentColumn);
			}

			if (!hideWeeklySummary) {
				columns.push(actionsColumn)
			}

			return columns;
		},
		[
			nameColumn,
			employeeNumberColumn,
			payGroupColumn,
			groupColumns,
			locationsColumn,
			jobsColumn,
			earningGroupsColumns,
			retroHoursColumn,
			paymentColumn,
			retroAmountColumn,
			actionsColumn,
			hideWeeklySummary,
			canViewRates,
			canViewRetro
		],
	);
};
